import { render, staticRenderFns } from "./NewSubcategory.vue?vue&type=template&id=9abd1bf4&scoped=true&"
import script from "./NewSubcategory.vue?vue&type=script&lang=js&"
export * from "./NewSubcategory.vue?vue&type=script&lang=js&"
import style0 from "./NewSubcategory.vue?vue&type=style&index=0&id=9abd1bf4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9abd1bf4",
  null
  
)

export default component.exports